import { render } from "./MpPendiente.vue?vue&type=template&id=7568a1d3"
import script from "./MpPendiente.vue?vue&type=script&lang=js"
export * from "./MpPendiente.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__